import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ToastProvider } from '@eombor/ui';
import { t } from '../shared/i18n/index.js';
import { LocaleProvider } from './LocaleProvider.js';
import { router } from './router.js';

/** Butun ilova uchun umumiy providerlar va marshrutlar. */
export const Providers = () => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Ombor ma'lumotlari tez o'zgaradi, lekin har fokusda so'rov yubormaymiz.
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider closeLabel={() => t('toast.close')}>
        <LocaleProvider>
          <RouterProvider router={router} />
        </LocaleProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
};
